import React from "react";
import LinkComp from "../LinkComp/LinkComp";
import BrokerageMap from "../BrokerageMap";
import {getData} from "../../requests/CRUD";
import {sortArray} from "../../utils";
import {TRAINING} from "../../consts/tables";

export default class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            chapters: [],
        }
    }

    componentDidMount() {
        getData({
            tableCode: TRAINING,
            options: {
                filter: [{
                    text: '',
                    code: 'DELETED',
                    type: 'null',
                }, {
                    text: 'brokerage-continuum',
                    code: 'PARENT_SLUG',
                    type: 'exact',
                }],
                filterType: 'and',
            },
        }).then(res => {
            if (res && res.success && Array.isArray(res.data) && res.data.length) {
                const chapters = sortArray(
                    res.data.map(chapter => {
                        return {
                            id: chapter.SLUG,
                            name: chapter.NAME,
                            index: parseInt(chapter.INDEX),
                        }
                    }), 'index');
                this.setState({chapters});
            }
        });
    }

    render() {
        const {chapters} = this.state;
        const base = arc.path.base;

        return (
            <div className='Training'>
                <div className='training-shell'>
                    <nav className='training-breadcrumb'>
                        <LinkComp to={base} className='training-breadcrumb__link'>Home</LinkComp>
                        <span className='training-breadcrumb__sep'>/</span>
                        <LinkComp to={`${base}training`} className='training-breadcrumb__link'>Training</LinkComp>
                        <span className='training-breadcrumb__sep'>/</span>
                        <span className='training-breadcrumb__current'>Brokerage Continuum</span>
                    </nav>

                    <div className='page-body-container'>
                        <div className='modules-section-heading'>
                            <div>
                                <div className='modules-section-title'>Summit Brokerage Continuum</div>
                                <div className='modules-section-copy'>
                                    The full brokerage journey, stage by stage to the summit.
                                </div>
                            </div>
                            <div className='modules-section-actions'>
                                <button
                                    className='button-new action'
                                    onClick={() => window.open(`${base}print-continuum/brokerage-continuum`, '_blank')}
                                >
                                    Print Continuum
                                </button>
                            </div>
                        </div>

                        <div className='training-map-container'>
                            <BrokerageMap chapters={chapters} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
